import PropTypes from 'prop-types';

const ArrowLeftIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.632 19h30.736c1.188 0 1.934.186 2.586.534.652.349 1.163.86 1.512 1.512.348.652.534 1.398.534 2.586v.736c0 1.188-.186 1.934-.534 2.586a3.635 3.635 0 0 1-1.512 1.512c-.652.348-1.398.534-2.586.534H8.632c-1.188 0-1.934-.186-2.586-.534a3.635 3.635 0 0 1-1.512-1.512C4.186 26.302 4 25.556 4 24.368v-.736c0-1.188.186-1.934.534-2.586a3.635 3.635 0 0 1 1.512-1.512C6.698 19.186 7.444 19 8.632 19z"
        fill={fill}
      />
    </svg>
  </div>
);

ArrowLeftIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

ArrowLeftIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default ArrowLeftIcon;
